import { render } from "./App.vue?vue&type=template&id=4065ed7c&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=4065ed7c&lang=less"

import exportComponent from "D:\\phpStudy_pro\\WWW\\drchat-v2\\front-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__